export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-07-04 at 18.55.23.dd0446b9.jpeg";